import { Instance, types } from 'mobx-state-tree';

export const CourseCoordinator = types.model('CourseCoordinatorModel', {
  batchId: '',
  semesterId: '',
});

export type CourseCoordinatorType = Instance<typeof CourseCoordinator>;
